import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import ProjectEditionButton from '../projectEditionButton/ProjectEditionButton';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ProjectDocumentsView = props => {
  const documentsCount = props.documents.length;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "col-4",
      children: [/*#__PURE__*/_jsxs("h2", {
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "project.documents.title"
        }), /*#__PURE__*/_jsx("span", {
          className: "separator information",
          children: documentsCount
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "card h-100",
        children: props.error ? /*#__PURE__*/_jsx("span", {
          "data-id": "error-message",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "error.generic"
          })
        }) : props.loading ? /*#__PURE__*/_jsx("span", {
          className: "loading-overlay"
        }) : /*#__PURE__*/_jsxs("ul", {
          children: [props.isProjectEditionAllowed && /*#__PURE__*/_jsx(ProjectEditionButton, {
            onEditButtonClick: props.onEditButtonClick
          }), props.documents.map((document, index) => /*#__PURE__*/_jsx("li", {
            className: "mb-5",
            children: document.label
          }, document.code || `CUSTOM-${index}`))]
        })
      })]
    })
  });
};
ProjectDocumentsView.defaultProps = {
  isProjectEditionAllowed: false,
  loading: true,
  error: false
};
ProjectDocumentsView.propTypes = {
  documents: PropTypes.array.isRequired,
  error: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  isProjectEditionAllowed: PropTypes.bool,
  onEditButtonClick: PropTypes.func
};
export default ProjectDocumentsView;